import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    listItem: {
      padding: theme.spacing(2),
    },
    checkedIcon: {
      color: theme.palette.success.main,
    },
    checkBox: {
      padding: theme.spacing(0),
    },
  }),
);

interface CheckBoxListProps {
  editable?: boolean;
  listItems: CheckListItem[];
  subheader?: string;
}

interface CheckListItem {
  label: string;
  fieldName: string;
  checked?: boolean;
  onToggle?: () => void;
}
export function CheckboxList(props: CheckBoxListProps) {
  const classes = useStyles();

  return (
    <List dense>
      {props.subheader && (
        <ListSubheader disableGutters sx={{ backgroundColor: "inherit" }}>
          {props.subheader}
        </ListSubheader>
      )}
      {props.listItems.map((listItem) => {
        const labelId = `checkbox-list-label-${listItem.fieldName}`;
        return (
          <ListItem
            key={listItem.fieldName}
            dense
            button={props.editable as any}
            onClick={props.editable ? listItem.onToggle : undefined}
            className={classes.listItem}
          >
            <ListItemIcon className="d-flex justify-content-start">
              {props.editable ? (
                <Checkbox
                  checked={listItem.checked}
                  tabIndex={-1}
                  disableRipple
                  readOnly
                  color="primary"
                  className={classes.checkBox}
                />
              ) : listItem.checked ? (
                <CheckCircleIcon className={classes.checkedIcon} />
              ) : (
                <CloseIcon color="disabled" />
              )}
            </ListItemIcon>
            <ListItemText id={labelId} primary={listItem.label} />
          </ListItem>
        );
      })}
    </List>
  );
}
